// src/campaigns/engine/campaign-priority.utils.ts

import { RawCampaignDefinition } from "../types/campaign.types";
import { fromISODate } from "./campaign-date.utils";

export function compareCampaignPriority(
  a: RawCampaignDefinition,
  b: RawCampaignDefinition
): number {
  const dateDiff = fromISODate(a.eventDate).getTime() - fromISODate(b.eventDate).getTime();

  if (dateDiff !== 0) return dateDiff;

  return b.priority - a.priority;
}

export function dedupeCampaignsById(campaigns: RawCampaignDefinition[]): RawCampaignDefinition[] {
  const seen = new Set<string>();

  return campaigns.filter((campaign) => {
    if (seen.has(campaign.id)) return false;
    seen.add(campaign.id);
    return true;
  });
}
